import { createContext, useContext, useEffect, useState } from 'react'
import type { ReactNode } from 'react'

interface ThemeContextValue {
  isDark: boolean
  toggleTheme: () => void
}

const ThemeContext = createContext<ThemeContextValue>({ isDark: true, toggleTheme: () => {} })

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [isDark, setIsDark] = useState(() => {
    const saved = localStorage.getItem('km-theme')
    const dark = saved ? saved === 'dark' : true
    // Inizializzazione sincrona per evitare flash al mount
    if (!dark) document.documentElement.classList.add('light')
    else document.documentElement.classList.remove('light')
    return dark
  })

  useEffect(() => {
    localStorage.setItem('km-theme', isDark ? 'dark' : 'light')
    // Applica/rimuove classe .light su <html> per sovrascrivere i token CSS
    document.documentElement.classList.toggle('light', !isDark)
  }, [isDark])

  return (
    <ThemeContext.Provider value={{ isDark, toggleTheme: () => setIsDark(d => !d) }}>
      {children}
    </ThemeContext.Provider>
  )
}

export const useTheme = () => useContext(ThemeContext)
